var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneArrowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 130,
    viewBox: "0 0 173 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.727 20.7666C139.082 22.8443 140.665 26.7157 139.454 29.8377C138.243 32.9596 117.28 86.1061 114.794 92.5153C112.307 98.9244 104.207 95.0849 101.682 94.1056C99.158 93.1262 81.4484 86.2556 79.1236 85.1818C76.7988 84.1079 71.8548 84.0717 75.7489 74.454C79.6431 64.8363 98.5265 18.4016 99.8781 14.4746C101.23 10.5476 102.869 8.95782 108.075 10.9775C114.146 13.3328 133.722 20.7557 133.722 20.7557L133.727 20.7666Z",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.252 24.6079C133.393 26.2144 134.509 29.4885 133.457 32.2009C132.405 34.9133 114.202 81.1558 112.042 86.725C109.881 92.2941 103.641 89.2703 101.681 88.5098C99.721 87.7493 86.0299 82.4377 84.2338 81.5923C82.4376 80.7468 78.551 80.8736 81.928 72.5071C85.305 64.1406 101.649 23.7244 102.841 20.3144C104.033 16.9044 105.376 15.4935 109.403 17.0557C114.098 18.8774 129.252 24.6079 129.252 24.6079Z",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.591 24.3652L122.679 27.9349",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 15.5C144.833 12.1667 150.4 4.8 154 2",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148 31.9156C151.867 33.1818 160.531 36.3725 164.255 39.0056",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150 21.0531C155.166 20.4074 166.934 19.3694 172.681 20.3836",
    stroke: "#EF7056",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0249 106.802C48.409 119.605 26.2335 119.8 11.5856 94.8864M5.63069 107.912C7.09675 102.458 9.90902 90.3142 9.42951 85.3706C15.0066 94.7444 17.824 95.4436 24.499 96.6171",
    stroke: "#EF7056",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneArrowIcon);
export default __webpack_public_path__ + "static/media/phone-arrow-icon.b60d050f27f62d8e2bc94e12bc881de3.svg";
export { ForwardRef as ReactComponent };